import { getDateString } from "@/util/dateUtils";

export type Year =
  `20${0 | 1 | 2 | 3 | 4}${0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9}`;

export type ChartDataPoint = Record<"date", string> &
  Partial<Record<Year, number>>;

type DateRangeMap = Record<string, Record<string, number>>;

/* Build an object with a key for each date in a range */
export const buildDateRangeMap = (start: string, end: string): DateRangeMap => {
  const dates: Record<string, Record<string, number>> = {};
  const startDate = new Date(start);

  while (getDateString(startDate) <= end) {
    dates[getDateString(startDate)] = {};
    startDate.setDate(startDate.getDate() + 1);
  }
  return dates;
};

/* Combine data from multiple lines into one */
export const combineData = (
  dateMap: DateRangeMap,
  lineCharts: ChartDataPoint[][],
) => {
  for (const lineData of lineCharts) {
    for (const dataPoint of lineData) {
      const { date, ...rest } = dataPoint;
      const dataForDate = dateMap[date];
      if (dataForDate) {
        dateMap[date] = { ...dataForDate, ...rest };
      }
    }
  }
  return Object.entries(dateMap).map(([dateKey, data]) => ({
    date: dateKey,
    ...data,
  }));
};

export const getMockData = (cohortYear: number, offset: number) => {
  const startDate = `${cohortYear - 1}-05-01`;
  const endDate = `${cohortYear}-08-31`;
  const range = buildDateRangeMap(startDate, endDate);
  const dataRange = Object.keys(range).map((range) => ({
    date: range,
  }));

  let curCount = Math.floor(Math.random() * 100) + 20;
  let rateOfChange = 0;

  return dataRange.map((point) => {
    rateOfChange = Math.max(
      (Math.floor(Math.random() * 3) - 1) * 0.1 + rateOfChange,
      0,
    );
    curCount = Math.round(curCount + rateOfChange);
    return {
      ...point,
      [cohortYear - offset]: curCount,
    };
  });
};

export const mockExistingData = (data: ChartDataPoint[], key: string) => {
  let curCount = 1000;
  let rateOfChange = 0;
  return data.map((point) => {
    rateOfChange = Math.max(
      (Math.floor(Math.random() * 3) - 1) * 1 + rateOfChange,
      0,
    );
    curCount = Math.round(curCount + rateOfChange);
    return {
      ...point,
      [key]: curCount,
    };
  });
};
